export default "__VITE_ASSET__CMXOysnf__"